var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_e_1",class:{ loaded: _vm.loaded, trans: _vm.trans }},_vm._l((_vm.text),function(c,i){return _c('span',{key:i,ref:"c",refInFor:true,staticClass:"c",class:{ cs: c==' ' }},[_vm._v(_vm._s(c))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fc6bb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/e_1.vue
// module id = null
// module chunks = 